/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m23.7 9.822c.19.211.282.491.252.773l-.508 4.878c-.054.509-.483.896-.995.896h-3.695v13.631c0 .552-.448 1-1 1h-6.096c-.552 0-1-.448-1-1v-13.631h-2.658c-.552 0-1-.448-1-1v-4.877c0-.553.448-1 1-1h2.658v-1.616c0-1.613.483-6.876 6.695-6.876l5.281.016c.551.001.997.449.997 1v4.806c0 .552-.448 1-1 1h-3.643c-.166 0-.234 0-.234.347v1.323h4.204c.283 0 .553.12.742.33zm-2.152 4.547.3-2.877h-4.094c-.552 0-1-.448-1-1v-2.323c0-1.622 1.122-2.347 2.234-2.347h2.643v-2.809l-4.281-.013c-3.878 0-4.692 2.652-4.692 4.876v2.616c0 .552-.448 1-1 1h-2.658v2.877h2.658c.552 0 1 .448 1 1v13.631h4.096v-13.631c0-.552.448-1 1-1z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;